/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Actions_RefreshInputs */

const nl_common_actions_refresh = /** @type {(inputs: Common_Actions_RefreshInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verversen`)
};

/**

* @param {Common_Actions_RefreshInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_actions_refresh = /** @type {((inputs?: Common_Actions_RefreshInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Actions_RefreshInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_actions_refresh(inputs)
});
export { common_actions_refresh as "common.actions.refresh" }